import { Box, Typography } from '@mui/material';

import {
  MarketingCtaBand,
  MarketingFeatureGrid,
  MarketingHero,
  MarketingStatRow,
} from '@/components/Marketing/blocks';
import { MarketingPageShell } from '@/components/Marketing/MarketingPageShell';
import { ServicesPlatformDiagram } from '@/components/Marketing/ServicesPlatformDiagram';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function ServicesPage() {
  usePageMeta(
    'Mortgage Services',
    'Wholesale rates, loan estimates, pre-approval, and investor programs from Unbeatable Loans.'
  );
  return (
    <MarketingPageShell
      title="We're Unbeatable."
      subtitle="Our tech replaces buyers agents. Wholesale rates, instant lender matching, and offer tools built for homebuyers and investors."
      heroAppend={<ServicesPlatformDiagram />}
    >
      <MarketingHero
        title="We started Unbeatable to help buyers save thousands."
        description="Our platform is designed for first-time homebuyers, homeowners, and investors to cut out middlemen. Create loan estimates, view properties, submit offers, and negotiate—with instant submission to 330+ lenders."
      />

      <MarketingFeatureGrid
        columns={{ xs: 12, md: 4 }}
        items={[
          {
            title: 'Mortgage Pre-Approval',
            body: 'Get pre-approved or make a plan after a quick consultation.',
          },
          {
            title: 'House Shopping',
            body: 'Start house shopping with numbers, not just listing links.',
          },
          {
            title: 'Loan Application',
            body: 'Quick and easy loan application to complete online.',
          },
        ]}
      />

      <MarketingStatRow
        stats={[
          { value: '7+', label: 'Years of experience' },
          { value: '$81M+', label: 'Funded' },
          { value: '331+', label: 'Mortgage lenders' },
          { value: '50', label: 'States' },
        ]}
      />

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 4, mb: 2 }}>
        Proudly offering 0% down and strategies for veterans
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 2, lineHeight: 1.7 }}
      >
        FHA from 3.5% down for first purchases, house hacks, and more. Cash-out
        and debt consolidation with funds in as little as 3 business days while
        keeping your low primary rate. Conventional loans driven by your income,
        credit, and assets. Investor programs with up to 90% financing. DSCR and
        long-term rental strategies focused on cash flow.
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>
        Our mission is your Unbeatable mortgage
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 2, lineHeight: 1.7 }}
      >
        Beyond popular products we offer niche options: asset qualifier, bank
        statement, non-warrantable condos, buy-before-you-sell, reverse, bridge,
        commercial, mixed-use, new construction, and construction loans.
      </Typography>
      <Box component="ul" sx={{ pl: 2, color: 'text.secondary' }}>
        {[
          'Asset Qualifier Mortgages',
          'Bank Statement Mortgages',
          'Non-Warrantable Condos',
          'Buy-before-you-sell',
          'Reverse Mortgages',
          'Bridge Loans',
          'Commercial Loans',
          'Mixed-use Loans',
          'New Construction',
          'Construction Loans',
        ].map((x) => (
          <li key={x}>
            <Typography variant="body2" component="span">
              {x}
            </Typography>
          </li>
        ))}
      </Box>

      <MarketingCtaBand
        title="Explore loan estimates and offers"
        subtitle="Use the platform to compare programs and move forward with confidence."
        to="/main"
        buttonLabel="Go to app"
      />
    </MarketingPageShell>
  );
}
